// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { useStrings } from '../store/hooks';

export enum DestinationType {
    GroupMembership = "GroupMembership",
    TeamsChannelMembership = "TeamsChannelMembership",
}